import React from 'react';

/**
 * Embedded video player for exercise demos. Accepts YouTube watch URLs,
 * youtu.be short URLs, Vimeo URLs, or direct embed URLs.
 * Falls back to a clickable link when the URL can't be parsed.
 */
export function VideoEmbed({ url, title = 'Exercise video', className = '' }) {
  const embed = toEmbedUrl(url);
  if (!embed) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer"
         className="text-xs text-brand underline" data-testid="video-link">
        Open video ↗
      </a>
    );
  }
  return (
    <div className={`relative w-full overflow-hidden rounded-lg bg-black ${className}`} style={{ aspectRatio: '16 / 9' }} data-testid="video-embed">
      <iframe
        src={embed}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 w-full h-full border-0"
      />
    </div>
  );
}

function toEmbedUrl(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const url = raw.trim();
  // Already an embed URL
  if (/\/embed\//.test(url)) return url;
  // YouTube long form
  const ytWatch = url.match(/(?:youtube\.com\/watch\?v=|youtube\.com\/shorts\/)([\w-]{6,})/);
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}`;
  // YouTube short
  const ytShort = url.match(/youtu\.be\/([\w-]{6,})/);
  if (ytShort) return `https://www.youtube.com/embed/${ytShort[1]}`;
  // Vimeo
  const vimeo = url.match(/vimeo\.com\/(\d{5,})/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return null;
}
